export default __webpack_public_path__ + "static/media/Waleed_Ahmed_Resume.0a39fb2e.pdf";